import { render, staticRenderFns } from "./DialogAddProduct.pug?vue&type=template&id=0ace6c26&lang=pug&"
import script from "./DialogAddProduct.vue?vue&type=script&lang=js&"
export * from "./DialogAddProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports